export default "__VITE_ASSET__Cm6f$Vr8__"